<template>
  <div class="container-fluid py-4 payment-page">

    <!-- ================= HEADER ================= -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap">

      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-credit-card fs-2 text-success"></i>

        <div>
          <h2 class="fw-bold mb-0">Moyens de paiement</h2>
          <small class="text-white-50">
            Gestion des moyens de paiement du système
          </small>
        </div>
      </div>

      <button
         v-if="$store.getters.hasPermission('PAYMENT_CREATE')"
        class="btn btn-success btn-lg shadow-sm btn-boutique mt-2 mt-md-0"
        @click="creation"
      >
        <i class="bi bi-plus-circle me-1"></i>
        Nouveau
      </button>

    </div>

    <!-- ================= FILTRES ================= -->
    <div class="card shadow-sm rounded card-boutique p-3 mb-4">

      <div class="row g-3 align-items-end">

        <div class="col-12 col-md-4">
          <label class="form-label fw-semibold">Rechercher</label>
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Nom..."
            class="form-control form-control-boutique"
          />
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label fw-semibold">Items</label>
          <select v-model="itemsperpage" class="form-select form-select-boutique">
            <option v-for="i in itemsPerPageT" :key="i" :value="i">{{ i }}</option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-boutique">
            <option v-for="(v,k) in orderByTabs" :key="k" :value="v">{{ k }}</option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-boutique">
            <option v-for="(v,k) in sortOrders" :key="k" :value="v">{{ k }}</option>
          </select>
        </div>

      </div>

    </div>

    <!-- ================= LOADER ================= -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-success" style="width:3rem;height:3rem;"></div>
      <p class="mt-3">Chargement...</p>
    </div>

    <!-- ================= TABLE ================= -->
    <div v-else class="card shadow-sm rounded card-boutique">

      <div class="table-responsive">

        <table class="table align-middle text-center mb-0 table-hover modern-table-boutique w-100">

          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th>Statut</th>
              <th>Créé le</th>
              <th>Mis à jour</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>

            <tr v-for="(mode, index) in filteredModes" :key="mode.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>

              <td class="fw-semibold">{{ mode.nom }}</td>

              <td>
                <span :class="mode.isEnabled ? 'badge bg-success' : 'badge bg-secondary'">
                  {{ mode.isEnabled ? 'Activé' : 'Désactivé' }}
                </span>
              </td>

              <td>{{ formatDate(mode.createdAt) }}</td>
              <td>{{ formatDate(mode.updatedAt) }}</td>

              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-success dropdown-toggle" data-bs-toggle="dropdown">
                    Actions
                  </button>

                  <ul class="dropdown-menu">
                    <li v-if="$store.getters.hasPermission('PAYMENT_UPDATE')">
                      <a class="dropdown-item" @click="modifier(mode.id)">
                        Modifier
                      </a>
                    </li>

                    <li v-if="$store.getters.hasPermission('PAYMENT_DELETE')">
                      <a class="dropdown-item text-danger" @click="supprimer(mode.id)">
                        Supprimer
                      </a>
                    </li>
                  </ul>

                </div>
              </td>

            </tr>

            <tr v-if="filteredModes.length === 0">
              <td colspan="6" class="text-center py-3">
                Aucun moyen de paiement
              </td>
            </tr>

          </tbody>

        </table>

      </div>

      <!-- ================= PAGINATION ================= -->
      <div class="d-flex justify-content-end p-3">

        <ul class="pagination pagination-boutique mb-0">

          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">
              Précédent
            </button>
          </li>

          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">
              {{ page }}
            </button>
          </li>

          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">
              Suivant
            </button>
          </li>

        </ul>

      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      isLoading: true,

      searchQuery: '',
      itemsperpage: 10,
      orderBy: 'mp.createdAt',
      sortOrder: 'desc',

      modesPaiement: [],
      totalItems: 0,
      currentPage: 1,

      itemsPerPageT: [2, 4, 6, 10],

      orderByTabs: {
        Nom: 'mp.nom',
        Création: 'mp.createdAt',
        'Mise à jour': 'mp.updatedAt'
      },

      sortOrders: {
        Croissant: 'asc',
        Décroissant: 'desc'
      }
    }
  },

  computed: {
    filteredModes() {
      if (!this.searchQuery) return this.modesPaiement
      const q = this.searchQuery.toLowerCase()

      return this.modesPaiement.filter(m =>
        (m.nom || '').toLowerCase().includes(q)
      )
    },

    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage)
    }
  },

  methods: {

    formatDate(date) {
      return date ? dayjs(date).format('DD/MM/YYYY HH:mm') : '-'
    },

    creation() {
      this.$router.push({ name: 'create_moyen' })
    },

    modifier(id) {
      this.$router.push({ name: 'edit_moyen', params: { id } })
    },

    async getModes() {
      try {
        this.isLoading = true

        const res = await api.getItems('moyen_paiements', {
          orderBy: this.orderBy,
          sortOrder: this.sortOrder,
          itemsperpage: this.itemsperpage,
          page: this.currentPage,
          search: this.searchQuery
        })

        const { data, meta } = res.data

        this.modesPaiement = data
        this.totalItems = meta?.total_records ?? data.length

      } catch (e) {
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },

    async supprimer(id) {
      if (!confirm("Voulez-vous supprimer ce moyen de paiement ?")) return

      try {
        await api.deleteItem('moyen_paiements', id)
        this.getModes()
      } catch (e) {
        alert("Erreur suppression")
      }
    },

    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.currentPage = page
      this.getModes()
    }
  },

  watch: {
    searchQuery() {
      this.currentPage = 1
      this.getModes()
    },
    itemsperpage() {
      this.currentPage = 1
      this.getModes()
    },
    orderBy() {
      this.getModes()
    },
    sortOrder() {
      this.getModes()
    }
  },

  created() {
    this.getModes()
  }
}
</script>

<style scoped>

/* ===== BOUTIQUE STYLE ===== */

.payment-page {
  background: #f5f7fb;
  min-height: 100vh;
}

/* HEADER */
.header-boutique {
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
  padding: 20px;
  border-radius: 18px;
}

/* CARD */
.card-boutique {
  border: none;
  border-radius: 18px;
}

/* INPUT */
.form-control-boutique,
.form-select-boutique {
  border-radius: 12px;
}

/* BUTTON */
.btn-boutique {
  border-radius: 12px;
}

/* TABLE */
.modern-table-boutique thead {
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
}

/* PAGINATION */
.pagination-boutique .page-link {
  border-radius: 50%;
  margin: 0 4px;
  min-width: 38px;
  text-align: center;
}

.pagination-boutique .page-item.active .page-link {
  background: #10b981;
  border-color: #10b981;
  color: white;
}

</style>